import * as React from "react";

interface InlineErrorProps {
  message: string;
}

export function InlineError({ message }: InlineErrorProps): React.JSX.Element {
  return (
    <div
      role="alert"
      className="flex items-start gap-2 mt-1.5 text-[12px] text-[var(--danger)] leading-[1.4]"
    >
      <svg
        className="w-[14px] h-[14px] flex-shrink-0 mt-px"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="12" />
        <line x1="12" y1="16" x2="12.01" y2="16" />
      </svg>
      <span>{message}</span>
    </div>
  );
}
